import * as R from 'ramda'

import {
  filterPosition,
  type LineupModel,
} from '@collector/desktop-feature-lineups'
import { SubParticipantPosition } from '@collector/sportsapi-client-legacy'
import type { SubParticipant } from '@collector/sportsapi-types'

export function keepWillNotPlaySubParticipants<T extends SubParticipant>(
  players: T[],
): T[] {
  return filterPosition(players, SubParticipantPosition.WillNotPlay)
}

/** Prefer the open lineup model; fall back to the session cache on reopen. */
export function subParticipantsKeptAfterLineupClear<T extends SubParticipant>(
  lineupPlayers: T[],
  cachedPlayers: T[],
): T[] {
  const source = lineupPlayers.length > 0 ? lineupPlayers : cachedPlayers

  return keepWillNotPlaySubParticipants(source)
}

/**
 * Deep snapshot of a lineup model.
 * `structuredClone` throws `DataCloneError` when players are Vue proxies.
 */
export function cloneLineupModel<T extends LineupModel>(lineup: T): T {
  return R.clone(lineup)
}
